import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { useTheme } from '@mui/material/styles';
// utils
// components
import { useChart } from 'components/chart';
import WidgetWrapper from './wrappers/WidgetWrapper';
import StyledChartWrapper from './wrappers/ChartWrapper';
import Label from 'components/label';
import { Box, Divider, Typography } from '@mui/material';

// ----------------------------------------------------------------------

AppTotalUsersChart.propTypes = {
    title: PropTypes.string,
    subheader: PropTypes.string,
    customLegend: PropTypes.bool,
    chartColors: PropTypes.arrayOf(PropTypes.string),
    chartData: PropTypes.array,
    chartInfo: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            value: PropTypes.number
        })
    )
};
AppTotalUsersChart.defaultProps = {
    chartData: [],
    chartInfo: []
};

export default function AppTotalUsersChart({
    title,
    subheader,
    chartColors,
    chartData,
    chartInfo,
    color = 'light',
    customLegend,
    sx,
    ...other
}) {
    const theme = useTheme();

    const chartLabels = chartData.map((i) => i.label);

    const chartSeries = chartData.map((i) => i.value);

    const chartOptions = useChart({
        series: chartSeries,
        labels: chartLabels,
        plotOptions: {
            pie: {
                donut: {
                    size: '40%',
                    labels: {
                        show: false
                    }
                },
                stroke: {
                    // colors: theme.palette.background.paper,
                    width: 4
                }
            }
        },
        // customLegend &&
        legend: {
            position: 'right',
            offsetY: 0,
            offsetX: 0,
            height: 230,
            formatter: (val, opts) =>
                `${val}: ${opts.w.globals.series[opts.seriesIndex]}`
        },
        tooltip: {
            enabled: true,
            fillSeriesColor: false,
            theme: 'light',
        },
        chart: {
            dropShadow: {
                enabled: true,
                blur: 5,
                left: 1,
                top: 1,
                opacity: 0.2
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'vertical',
                shadeIntensity: 0.5,
                gradientToColors: chartData.map((i) => i.endColor),
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            }
        },
        colors: chartData.map((i) => i.color)
    });

    return (
        <WidgetWrapper
            title={title}
            sx={{
                backgroundColor: theme.palette.background.default
            }}
        >
            <Box
                sx={{
                    p: 4,
                    pb: 1
                }}
                dir="ltr"
            >
                <StyledChartWrapper
                    sx={{ maxWidth: 450, height: 200, margin: '0 auto' }}
                >
                    <ReactApexChart
                        type="donut"
                        series={chartSeries}
                        options={chartOptions}
                        height={200}
                    />
                </StyledChartWrapper>
                <Divider />
                <Box>
                    {chartInfo.map((item, index) => {
                        const percentage = (
                            (item.value /
                                chartInfo
                                    .map((i) => i.value)
                                    .reduce((a, b) => a + b, 0)) *
                            100
                        ).toFixed(0);

                        const colorLabel = percentage > 50 ? 'success' : 'error';
                        return (
                            <Box
                                key={index}
                                sx={{
                                    mt: 2,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <Label color={colorLabel} sx={{
                                    lineHeight: 24,
                                    fontSize: 16,
                                    fontWeight: 'bold',
                                    width: 90,
                                    height: 40,
                                    borderRadius: 15,
                                    borderColor: `${colorLabel}.mainLight`,
                                    borderStyle: 'solid',
                                }}>{percentage}%</Label>
                                <Box
                                    sx={{
                                        ml: 1,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    <Typography variant="body1">
                                        {item.title}
                                    </Typography>
                                    <Typography variant="subtitle2">
                                        {item.subtitle}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </WidgetWrapper>
    );
}
